/* eslint-disable no-unused-vars */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable max-len */
/* eslint-disable react/style-prop-object */
import React, {
    useEffect, useState, useCallback, useContext,
} from 'react';
import { motion } from 'framer-motion';
import moment from 'moment';
import { distributorService } from '../../../service/distributor.service';
import Pagination from '../../../Components/Pagination';
import EmptyScreen from '../../../Components/GlobalEmplyPage';
import IndentListSkeleton from './indentlistSkeleton';
import IndentFilterModal from './FilterModal';
import HeaderContext from '../../../Components/Context/HeaderContext';
import { CamelCase, PriceHandler } from '../../../redux/helper/CamelCase';

function IndentReport() {
    const {
        SetSuccessMessage,
    } = useContext(HeaderContext);
    const [indentReportList, setIndentReportList] = useState([]);
    const [sortType, setsortType] = useState('CREATED_DATE+desc');
    const [currentPage, setCurrentPage] = useState(1);
    const [searchValue, setsearchValue] = useState('');
    const [totalPage, setTotalPage] = useState('');
    const [alldata, setalldata] = useState({});
    const [loading, setLoading] = useState(true);
    const [filterModal, setFilterModal] = useState(false);
    const [emptyData, setEmptyData] = useState(false);
    const [filterValue, setfilterValue] = useState('');
    const [selected, setselected] = useState({
        start_date: '',
        end_date: '',
    });
    const [exportClick, setexportClick] = useState(false);
    const [exportSelected, setexportSelected] = useState('');
    const [Filter, setFilter] = useState({
        customer_category: [],
        order_category: [],
        wf_status: [],
        type: [],
    });

    const handleIndentReports = useCallback((() => {
        distributorService.MISIndentReport(currentPage, sortType, searchValue, filterValue).then((response) => {
            if (response.error === false && response.data.success_status === true) {
                if (response.data.data.length === 0) {
                    setLoading(false);
                    setEmptyData(true);
                } else {
                    setEmptyData(false);
                    setLoading(false);
                }
                setLoading(false);
                setIndentReportList(response.data.data);
                setalldata(response);
                setCurrentPage(response.data.current_page);
                setTotalPage(response.data.number_of_pages);
            } else {
                setLoading(false);
                setalldata([]);
            }
        });
    }), [currentPage, searchValue, sortType, filterValue]);

    const handlePageClick = async (data) => {
        setLoading(false);
        const page = data.selected + 1;
        setCurrentPage(page);
    };

    const handleFilter = (filterUrl) => {
        if (filterUrl.length > 0 && filterValue !== filterUrl) {
            setLoading(true);
            setCurrentPage(1);
            setfilterValue(filterUrl);
        } else {
            setLoading(false);
            setfilterValue(filterUrl);
        }
    };

    const handleExport = useCallback((() => {
        distributorService.MISIndentReport(currentPage, sortType, searchValue, filterValue, exportSelected).then((val) => {
            if (val.data.success_status) {
                // setshowPopup(true);
                SetSuccessMessage(val.data.message);
                setexportClick(false);
                setexportSelected('');
                window.open(val.data.url, '_blank');
                setTimeout(() => {
                    // settitle('');
                    SetSuccessMessage('');
                }, 2000);
            }
        });
    }), [exportSelected]);

    useEffect(() => {
        if (exportSelected !== '') {
            handleExport();
        }
    }, [handleExport]);

    useEffect(() => {
        handleIndentReports();
    }, [handleIndentReports]);

    return (
        <div className="py-6 pr-[18px] main-screen">
            <div className="flex justify-between pb-[18px]">
                <h5 className="text-xs4 font-normal text-[#555259]">Indent Report</h5>
                <div className="flex">
                    <button
                        type="button"
                        className="bg-[#F5F5FA] font-bold text-xs h-9 text-[#555259] border-2 border-[#E9EDF4] py-1 px-4 rounded-[9px] mr-2.5"
                        style={{
                            border: '2px solid #E9EDF4',
                        }}
                        data-bs-toggle="modal"
                        data-bs-target="#filtermodal"
                        onClick={() => setFilterModal(true)}
                    >
                        Filter
                    </button>
                    <div className="relative mr-2">
                        <label htmlFor="search" />
                        <input
                            type="text"
                            name="search"
                            id="search"
                            className="hidden w-[230px] h-[35px] bg-[#FFFFFF] rounded-lg outline-0 shadow-s3 text-xs2 font-semibold text-[#808285] placeholder:font-semibold placeholder:text-xs2 placeholder:text-[#808285] pl-[35px] pr-[15px]"
                            placeholder="Search"
                            value={searchValue}
                            onChange={(e) => {
                                setsearchValue(e.target.value);
                                setCurrentPage(1);
                            }}
                            autoComplete="off"
                        />
                        <img src="/images/Group-279.svg" alt="icon" className="absolute top-3 left-[15px] cursor-pointer" />
                    </div>
                    <div className="mr-2 dropdown relative">
                        <button
                            type="button"
                            id="exportDropdown"
                            data-bs-toggle="dropdown"
                            aria-expanded="false"
                            className="dropdown-toggle h-[35px] text-xs2 font-semibold text-[#555259] w-[79px] border border-[#555259] rounded-lg"
                            onClick={() => setexportClick(!exportClick)}
                        >
                            Export
                        </button>
                        <ul className={`dropdown-menu ${exportClick === true ? 'show' : 'hidden'} min-w-[100px] absolute bg-[#FFFFFF] rounded-lg shadow-s2 z-[9999]`} aria-labelledby="exportDropdown">
                            <li className="mx-[18px] pb-1.5 mt-5 hover:bg-[#F2F2F3] hover:rounded export">
                                <a
                                    className="dropdown-item text-xs5 font-normal text-[#555259] w-full inline-block px-1.5 py-0.5"
                                    href="#"
                                    onClick={() => {
                                        setexportSelected('csv');
                                    }}
                                >
                                    CSV

                                </a>
                            </li>
                            <li className="mx-[18px] pb-1.5 hover:bg-[#F2F2F3] hover:rounded">
                                <a
                                    className="dropdown-item text-xs5 font-normal text-[#555259] w-full inline-block px-1.5 py-0.5"
                                    href="#"
                                    onClick={() => setexportSelected('pdf-converter')}
                                >
                                    PDF

                                </a>
                            </li>
                            <li className="mx-[18px] pb-1.5 mb-3 hover:bg-[#F2F2F3] hover:rounded">
                                <a
                                    className="dropdown-item text-xs5 font-normal text-[#555259] w-full inline-block px-1.5 py-0.5"
                                    href="#"
                                    onClick={() => setexportSelected('excel')}
                                >
                                    Excel

                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            {loading ? <IndentListSkeleton /> : (
                <div>
                    {indentReportList.length > 0 && (
                        <div
                            className="overflow-auto dropdown-menu pb-7 relative z-10"
                            style={{ height: 'calc(100vh - 298px)' }}
                        >
                            <table className="w-full table-auto relative">
                                <thead className="sticky top-0 left-0 z-[2]">
                                    <tr className="bg-[#555259] h-10">
                                        <th className="py-2.5 px-6 rounded-bl-lg rounded-tl-lg min-w-[171px] sticky top-0 left-0 bg-[#555259]" scope="col">
                                            <span className="text-xs5 font-bold text-[#FFFFFF]">
                                                Indent No.
                                            </span>
                                        </th>
                                        <th scope="col" className="py-2.5 px-7 min-w-[168px]">
                                            <span className="text-xs5 font-bold text-[#FFFFFF] flex items-center justify-center">
                                                Order No.
                                            </span>
                                        </th>
                                        <th scope="col" className="py-2.5 px-7 min-w-[200px]">
                                            <span className="text-xs5 font-bold text-[#FFFFFF] flex items-center">
                                                Order Acceptance No.
                                            </span>
                                        </th>
                                        <th scope="col" className="py-2.5 px-7 min-w-[150px] text-center flex justify-center items-center pt-4">
                                            <span className="text-xs5 font-bold text-[#FFFFFF] flex items-center">
                                                Order Type
                                            </span>
                                        </th>
                                        <th scope="col" className="py-2.5 px-7 min-w-[160px]">
                                            <span className="text-xs5 font-bold text-[#FFFFFF] flex items-center justify-center">
                                                Plant Name
                                            </span>
                                        </th>
                                        <th scope="col" className="py-2.5 px-7 min-w-[188px]">
                                            <span className="text-xs5 font-bold text-[#FFFFFF] flex items-center justify-center">
                                                Customer Name
                                            </span>
                                        </th>
                                        <th scope="col" className="py-2.5 px-7 min-w-[200px]">
                                            <span className="text-xs5 font-bold text-[#FFFFFF] flex items-center">
                                                Customer Category
                                            </span>
                                        </th>
                                        <th scope="col" className="py-2.5 px-7 min-w-[152px]">
                                            <span className="text-xs5 font-bold text-[#FFFFFF] flex items-center">
                                                Order Source
                                            </span>
                                        </th>
                                        <th scope="col" className="py-2.5 px-7 min-w-[200px]">
                                            <span className="text-xs5 font-bold text-[#FFFFFF] flex items-center justify-center">
                                                Order Category
                                            </span>
                                        </th>
                                        <th scope="col" className="py-2.5 px-7 min-w-[200px]">
                                            <span className="text-xs5 font-bold text-[#FFFFFF] flex items-center">
                                                Created Date
                                                <a href="#" className="pl-[5px]">
                                                    <motion.img
                                                        animate={{ rotate: sortType === 'CREATED_DATE+asc' ? 180 : 0 }}
                                                        className={`${sortType === 'CREATED_DATE+desc' ? 'image-rotate' : ''}`}
                                                        src="/images/sort.svg"
                                                        alt="icon"
                                                        onClick={() => {
                                                            if (sortType === 'CREATED_DATE+asc') {
                                                                setsortType('CREATED_DATE+desc');
                                                            } else if (sortType === 'CREATED_DATE+desc') {
                                                                setsortType('CREATED_DATE+asc');
                                                            } else {
                                                                setsortType('CREATED_DATE+asc');
                                                            }
                                                            // setCurrentPage(1);
                                                            // setisLoaded(true);
                                                        }}
                                                    />
                                                </a>
                                            </span>
                                        </th>
                                        <th scope="col" className="py-2.5 px-7 min-w-[152px]">
                                            <span className="text-xs5 font-bold text-[#FFFFFF] flex items-center">
                                                Total Lines
                                            </span>
                                        </th>
                                        <th scope="col" className="py-2.5 px-7 min-w-[208px]">
                                            <span className="text-xs5 font-bold text-[#FFFFFF] flex items-center justify-center">
                                                Amount
                                                <a href="#" className="pl-[5px]">
                                                    <motion.img
                                                        animate={{ rotate: sortType === 'AMOUNT+asc' ? 180 : 0 }}
                                                        className={`${sortType === 'AMOUNT+desc' ? 'image-rotate' : ''}`}
                                                        src="/images/sort.svg"
                                                        alt="icon"
                                                        onClick={() => {
                                                            if (sortType === 'AMOUNT+asc') {
                                                                setsortType('AMOUNT+desc');
                                                            } else if (sortType === 'AMOUNT+desc') {
                                                                setsortType('AMOUNT+asc');
                                                            } else {
                                                                setsortType('AMOUNT+asc');
                                                            }
                                                            // setCurrentPage(1);
                                                            // setisLoaded(true);
                                                        }}
                                                    />
                                                </a>
                                            </span>
                                        </th>
                                        <th scope="col" className="py-2.5 px-7 min-w-[208px] rounded-br-lg rounded-tr-lg">
                                            <span className="text-xs5 font-bold text-[#FFFFFF] flex items-center justify-center">
                                                Status
                                            </span>
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {indentReportList.length > 0 && indentReportList.map((item) => (
                                        <tr className="bg-[#FFFFFF] border-b border-[#DFEAF7]">
                                            <td
                                                className="text-sm font-normal text-[#090406] py-2.5 px-7 sticky left-0 flex justify-center items-center pt-4"
                                                style={{
                                                    background: 'rgba(255, 255, 255, 0.45)',
                                                    backdropFilter: 'blur(5.5px)',
                                                }}
                                            >
                                                {item?.INDENT_NUMBER}
                                            </td>
                                            <td className="text-sm font-normal text-[#090406] py-2.5 px-7 text-center">
                                                {item?.ORDER_NUMBER}
                                            </td>
                                            {item?.ORDER_ACCEPTANCE_NUMBER === null ? (
                                                <td className="text-sm font-normal text-[#090406] text-center py-2.5 px-7">
                                                    -
                                                </td>
                                            )
                                                : (
                                                    <td className="text-sm font-normal text-[#090406] text-center py-2.5 px-7">
                                                        {item?.ORDER_ACCEPTANCE_NUMBER}
                                                    </td>
                                                )}
                                            <td className="text-sm font-normal text-[#090406] py-2.5 px-7 text-center">
                                                {item?.ORDER_TYPE}
                                            </td>
                                            <td className="text-sm font-normal py-2.5 px-7 text-center">
                                                {item?.PLANT_NAME}
                                            </td>
                                            <td className="text-sm font-normal text-[#090406] py-2.5 px-7 text-center">
                                                {item?.CUSTOMER_NAME}
                                            </td>
                                            <td className="text-sm font-normal text-[#090406] py-2.5 px-7 text-center">
                                                {item?.CUSTOMER_CATEGORY}
                                            </td>
                                            <td className="text-sm font-normal text-[#090406] py-2.5 px-7 text-center">
                                                {item?.ORDER_SOURCE}
                                            </td>
                                            <td className="text-sm font-normal text-[#090406] py-2.5 px-7 text-center">
                                                {item?.ORDER_CATEGORTY}
                                            </td>
                                            <td className="text-sm font-normal text-[#090406] py-2.5 px-7 text-center">
                                                {moment(item?.CREATED_DATE).subtract({ hours: 5, minutes: 30 }).format('DD-MMM-YYYY, HH:mm:ss')}
                                            </td>
                                            <td className="text-sm font-normal text-[#090406] py-2.5 px-7 text-center">
                                                {item.TOTAL_LINE || 1}
                                            </td>
                                            <td className="text-sm font-normal text-[#090406] py-2.5 px-7 text-center">
                                                {PriceHandler(item?.AMOUNT)}
                                            </td>
                                            <td className="text-sm font-normal text-[#090406] py-2.5 px-7 text-center">
                                                {item?.STATUS}
                                            </td>
                                        </tr>

                                    ))}

                                </tbody>
                            </table>
                        </div>
                    )}
                    {!loading && indentReportList && indentReportList.length > 0 && (
                        <Pagination
                            handlePageClick={handlePageClick}
                            totalPage={totalPage}
                            List={alldata}
                            currentPage={currentPage}
                        />
                    )}
                    {filterModal && (
                        <IndentFilterModal
                            handleFilter={handleFilter}
                            filterModal={filterModal}
                            setFilterModal={setFilterModal}
                            selected={selected}
                            setselected={setselected}
                            Filter={Filter}
                            setFilter={setFilter}
                            filterValue={filterValue}
                            setfilterValue={setfilterValue}
                            handleIndentReports={handleIndentReports}
                            SetSuccessMessage={SetSuccessMessage}
                        />
                    )}
                </div>
            )}

            {emptyData && (
                <EmptyScreen
                    search="yes"
                    text="no Indent Report"
                    buttonRequired={false}
                    all={searchValue.length > 0 ? 'under searched term' : 'found'}
                />
            )}
        </div>
    );
}

export default IndentReport;
